import React from 'react'
import "./Letreiro.css";

function Letreiro() {
  return (
    <div className='Letreiro-container'>
      <section className="social-mediaL">
        <div className="social-media-wrapL">
          <div className="footer-logoL">
            <div className="social-logoL">Sobre Nós - Quem Somos?</div>
            <div className="social-secondL">Sobre</div>
          </div>
        </div>
      </section>
      </div>
  )
}

export default Letreiro